import React from "react";
import CmmsWorkOrders from "../features/cmmsWorkOrders";

export default function CmmsWorkOrdersPage() {
  return (
    <CmmsWorkOrders />
  );
}
